// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3jIp8","fileBtn":"File_fileBtn__1hXhx","closeBtn":"File_closeBtn__2HJjQ","fileSelected":"File_fileSelected__2sptI","disabled":"File_disabled__2Y1UB"};